import { render, staticRenderFns } from "./LightboxElements.vue?vue&type=template&id=736b94fd&scoped=true&"
import script from "./LightboxElements.vue?vue&type=script&lang=js&"
export * from "./LightboxElements.vue?vue&type=script&lang=js&"
import style0 from "./LightboxElements.vue?vue&type=style&index=0&id=736b94fd&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "736b94fd",
  null
  
)

export default component.exports